// extracted by mini-css-extract-plugin
export default {"container":"swNZY","wrapper":"_6ux15"};